import * as React from 'react';
import { ModalView } from '@cian/ui-kit';
import { Button } from '@cian/button-component';
import * as styles from './index.css';

const successIcon = require('./success.svg') as string;

export interface IDealRentSuccessModalProps {
  isOpen: boolean;
  closeModal(): void;
}

export const DealRentSuccessModal = ({ isOpen, closeModal }: IDealRentSuccessModalProps) => {
  return (
    <ModalView onClose={closeModal} custom={{ open: isOpen, mediaType: 'desktop' }}>
      <div className={styles['container']}>
        <img src={successIcon} />
        <h1 className={styles['title']}>Анкета отправлена</h1>
        <div className={styles['text']}>Вам придёт СМС с ответом собственника</div>
        <Button onClick={closeModal}>Хорошо</Button>
      </div>
    </ModalView>
  );
};
